export default "__VITE_ASSET__COwnesmZ__"